module.exports = __webpack_public_path__ + "a5b9cd213d46cfd4939c142dd0e64deb.png";